// Import the RTK Query methods from the React-specific entry point
import {
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError
} from "@reduxjs/toolkit/query/react"
import { RTK_SLICE_API_LIST } from "../../common/constants"
import { setSessionExpired } from "../slices/auth"

const axiosBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_HOST ?? "/",
  credentials: "include",
  prepareHeaders: (headers: Headers, { getState }: any) => {
    const token = getState().auth.user?.sessid
    if (token) {
      headers.set("Authorization", token)
    }
    return headers
  }
})

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await axiosBaseQuery(args, api, extraOptions)

  if (
    result.data &&
    (result.data as any)?.status === "error" &&
    (result.data as any)?.message === "not allowed to do that"
  ) {
    const currentPath = window.location.pathname
    if (!currentPath.startsWith("/user/login")) {
      // Verify if the session is actually expired by checking /api/v1/me
      const meResult = await axiosBaseQuery("/api/v1/me", api, extraOptions)
      const isSessionValid =
        meResult.data && (meResult.data as any)?.status !== "error"

      if (!isSessionValid) {
        api.dispatch(setSessionExpired(true))
      }
    }
  }

  return result
}

export const getTags = (reducerPath: string, key: string, result?: any[]) => [
  ...(result ?? []).map(
    item =>
      ({
        type: reducerPath as any,
        id: item[key]
      } as const)
  ),
  { type: reducerPath as any, id: RTK_SLICE_API_LIST }
]
